import { Tabs, Tab } from "@mui/material";
import { SearchType } from "@shared/publicportal/contracts/Search";
import "./SearchTypeSwitchingTabs.css";
import { memo } from "react";
import { useDeviceDetect } from "@mirage/hooks/useDeviceDetect";

interface SearchTypeSwitchingTabsProps {
    searchType: SearchType;
    onSearchTypeChanged: (searchType: SearchType) => void;
}

const SearchTypeSwitchingTabs: React.FC<SearchTypeSwitchingTabsProps> = memo(({ searchType, onSearchTypeChanged }) => {
    const { isMobile } = useDeviceDetect();
    return (
        <Tabs
            className="search-type-switching-tab-container"
            aria-label="Select a search type"
            variant="scrollable"
            scrollButtons="auto"
            value={searchType}
            onChange={(e, selectedSearchType) => {
                onSearchTypeChanged(selectedSearchType);
            }}
        >
            <Tab className="search-type-switching-tab" disableRipple key="simple-search" label="Simple" value="Simple" />
            <Tab className="search-type-switching-tab" disableRipple key="advanced-search" label="Advanced" value="Advanced" />
            {isMobile ? null : <Tab className="search-type-switching-tab" disableRipple key="map" label="Map" value="Map" />}
        </Tabs>
    );
});

export default SearchTypeSwitchingTabs;
